import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { communicationStageApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { CommunicationStageFormData } from '../types/communication-stage';

export function useCommunicationStages() {
  return useQuery({
    queryKey: queryKeys.communicationStages.list(),
    queryFn: () => communicationStageApi.listStages(),
  });
}

export function useUpdateCommunicationStage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: CommunicationStageFormData }) =>
      communicationStageApi.updateStage(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.communicationStages.list() }),
  });
}
